const x = {
  content: `Als Mitglied der Wasserstoff-Kompetenzregion *Düssel.Rhein.Wupper* treibt die Stadt Wuppertal 
die Wasserstoff-Mobilität im öffentlichen Sektor voran. Die Kompetenzregion mit den weiteren 
Städten Düsseldorf und Duisburg, dem Rhein-Kreis Neuss und den Unternehmen Wuppertaler Stadtwerke (WSW), 
Stadtwerke Düsseldorf und Air Liquide ist Sieger des in 2018 gestarteten Landeswettbewerbs "Modellkommune/-region Wasserstoffmobilität NRW". 
Das prämierte Konzept der Kompetenzregion basiert auf einer von den WSW und der Abfallwirtschaftsgesellschaft Wuppertal (AWG) 
entwickelten geschlossenen Wertschöpfungskette, in der Wasserstoff lokal im AWG-Müllheizkraftwerk Korzert produziert 
und in der Wasserstoff-Busflotte der WSW genutzt wird.

Im privaten Sektor ist die Verfügbarkeit von Wasserstofftankstellen für Brennstoffzellenfahrzeuge entscheidend 
für den Ausbau der Wasserstoff-Mobilität. Solche Tankstellen halten flüssigen oder komprimiert 
gasförmigen Wasserstoff in ihren Tanks bereit. Die Region Rhein-Ruhr gehört neben Hamburg, Berlin, Frankfurt, 
Nürnberg, Stuttgart und München zu den sieben Schwerpunktregionen Deutschlands, in denen eine 
flächendeckende Wasserstoff-Infrastruktur aufgebaut werden soll. Zusätzlich sollen Wasserstofftankstellen 
entlang der verbindenden Autobahnen und Fernstraßen entstehen. Auch wenn es Stand 11/2020 erst eine 
Wasserstofftankstelle in Wuppertal gibt, ist also damit zu rechnen, dass recht kurzfristig 
weitere Wasserstofftankstellen entstehen werden.`,
};
export default x;
